<div class="modal-header">
  <h5 class="modal-title">Edit Team Name and Image</h5>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="nav-tabs-horizontal tab-body">
  <ul ngbNav #tabSet="ngbNav" class="nav-tabs">
    <li ngbNavItem>
      <a ngbNavLink>Overview</a>
      <ng-template ngbNavContent>
        <form (ngSubmit)="onFormSubmit(f)" #f="ngForm" id="teamEditForm">
          <div class="modal-body">
            <div class="team-name form-group mb-0 pb-2">
              <label><strong>Team Name:</strong></label>
              <div class="input-group">
                <input class="form-control"
                        name="teamName"
                        id="teamNameForm"
                        [(ngModel)]="name">
              </div>
              <div class="pt-2">
                Please note that editing your team name does not update any of the information on your Team Fundraising Page.
                You can find and update this information in the Fundraising Pages section under the page options tab.
              </div>
            </div>
            <div class="mt-4"><label><strong>Team Image:</strong></label></div>
            <div class="team-image form-group row mb-0 pb-2">
              <div class="col-8">
                <div>
                  <p>
                    You can edit your team image by choosing an image from your gallery, or uploading a new one using
                    the tabs above
                  </p>
                  <p>Ideal size is 200 x 200 and the file must be a JPG, GIF, or PNG</p>
                </div>
              </div>
              <div class="col-4">
                <img id="teamLogo" class="img-responsive" [src]="currentImage.fullImagePath"/>
              </div>
            </div>
          </div>
        </form>
        <div class="d-flex flex-row justify-content-end pt-3 edit-team-buttons">
          <div class="btn-group row mr-0" role="group">
            <div class="d-flex">
              <button class="btn btn-outline-primary btn-block mr-2" type="button" (click)="closeModal()">Cancel</button>
              <button form="teamEditForm" class="btn btn-primary">Save</button>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li ngbNavItem>
      <a ngbNavLink>Gallery</a>
      <ng-template ngbNavContent>
        <app-gallery [currentImage]="currentImage" [isTeam]="true"></app-gallery>
      </ng-template>
    </li>
    <li ngbNavItem>
      <a ngbNavLink>Upload a New Image</a>
      <ng-template ngbNavContent>
        <app-upload [isTeam]="true"></app-upload>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="tabSet" class="mt-2"></div>

</div>
